module.exports = __webpack_public_path__ + "img/2_199.364c9d9e.png";